<template>
    <div class="diagram">
        <div class="diagram-page">
            <div class="diagram-top-bg"></div>
            <div class="diagram-content width90p">
                <!-- 1. 顶部菜单栏 -->
                <diagram-title-bar></diagram-title-bar>
                <!-- 2. 顶部表单 -->
                <diagram-form v-bind:parentNode="parentNode"></diagram-form>
                <!-- 正时起卦 -->
                <div v-if="curDiagramChooseTypeData.value == 1" class="diagram-time-box">
                    <button class="button-blue" @click="clickStart"></button>
                </div>
                <!-- 手工指定 -->
                <div v-else-if="curDiagramChooseTypeData.value == 2" class="diagram-content-box mt15 diagram-hand-box">
                    <div class="diagram-content-title">手工指定</div>
                    <diagram-hand-list v-bind:parentNode="parentNode"></diagram-hand-list>
                    <div class="diagram-content-btn">
                        <button class="button-blue" @click="clickStart"></button>
                    </div>
                </div>
                <!-- 卦名起卦 -->
                <div v-else-if="curDiagramChooseTypeData.value == 3" class="diagram-content-box mt15 diagram-name-box">
                    <diagram-choose-diagram v-bind:parentNode="parentNode"></diagram-choose-diagram>
                    <div class="diagram-content-btn">
                        <button class="button-blue" @click="clickStart"></button>
                    </div>
                </div>
                <!-- 三位数报数 -->
                <div v-else-if="curDiagramChooseTypeData.value == 4" class="diagram-content-box mt15 diagram-number-box">
                    <div class="diagram-content-title">请输入三位数报数</div>
                    <diagram-choose-number v-bind:parentNode="parentNode" :numberLen="3"></diagram-choose-number>
                    <div class="diagram-content-btn">
                        <button class="button-blue" @click="clickStart"></button>
                    </div>
                </div>
                <!-- 固定三位数 -->
                <div v-else-if="curDiagramChooseTypeData.value == 5" class="diagram-content-box mt15 diagram-number-box">
                    <div class="diagram-content-title">请输入固定三位数</div>
                    <diagram-choose-number v-bind:parentNode="parentNode" :numberLen="3"></diagram-choose-number>
                    <div class="diagram-content-btn">
                        <button class="button-blue" @click="clickStart"></button>
                    </div>
                </div>
                <!-- 固定四位数 -->
                <div v-else-if="curDiagramChooseTypeData.value == 6" class="diagram-content-box mt15 diagram-number-box">
                    <div class="diagram-content-title">请输入固定四位数</div>
                    <diagram-choose-number v-bind:parentNode="parentNode" :numberLen="4"></diagram-choose-number>
                    <div class="diagram-content-btn">
                        <button class="button-blue" @click="clickStart"></button>
                    </div>
                </div>
                <!-- 铜钱起卦 -->
                <div v-else-if="curDiagramChooseTypeData.value == 7" class="diagram-content-box mt15 diagram-number-box">
                    <diagram-choose-copper v-bind:parentNode="parentNode"></diagram-choose-copper>
                    <div class="diagram-content-btn" v-if="curChoosedCoper == 7">
                        <button class="button-blue" @click="clickStart"></button>
                    </div>
                </div>
            </div>
            <!-- 子路由 -->
            <router-view></router-view>
            <!-- 选择时间弹框 -->
            <van-popup v-bind:value="showTimePanel" position="bottom" @click-overlay="clickShowTimePanelOverlay">
                <input-birthday-panel v-bind:parentNode="parentNode"></input-birthday-panel>
            </van-popup>
            <!-- 选择起卦方式弹框 -->
            <van-popup :style="'border-radius: 10px 10px 0 0'" :value="showChooseType" position="bottom" @click-overlay="clickCancel">
                <diagram-choose-type></diagram-choose-type>
            </van-popup>
            <!-- 手工指定爻弹框 -->
            <van-popup :value="showChooseLine" position="bottom" @click-overlay="clickLineCancel">
                <diagram-choose-line></diagram-choose-line>
            </van-popup>
        </div>
    </div>
</template>

<script>
import DiagramTitleBar from '../layouts/diagram/DiagramTitleBar.vue';
import DiagramForm from '../layouts/diagram/DiagramForm.vue';
import InputBirthdayPanel from '../components/InputBirthdayPanel.vue'
import DiagramChooseType from '../layouts/diagram/DiagramChooseType.vue';
import DiagramHandList from '../layouts/diagram/DiagramHandList.vue';
import DiagramChooseLine from '../layouts/diagram/DiagramChooseLine.vue';
import DiagramChooseDiagram from '../layouts/diagram/DiagramChooseDiagram.vue';
import DiagramChooseNumber from '../layouts/diagram/DiagramChooseNumber.vue';
import DiagramChooseCopper from '../layouts/diagram/DiagramChooseCopper.vue';
export default {
    name: 'Diagram',
    components: { DiagramTitleBar, DiagramForm, InputBirthdayPanel, DiagramChooseType, DiagramHandList, DiagramChooseLine, DiagramChooseDiagram, DiagramChooseNumber, DiagramChooseCopper },
    computed: {
        showTimePanel() {
            return this.$store.state.diagram.showTimePanel;
        },
        showChooseType() {
            return this.$store.state.diagram.showChooseType;
        },
        curDiagramChooseTypeData() {
            return this.$store.state.diagram.curDiagramChooseTypeData;
        },
        showChooseLine() {
            return this.$store.state.diagram.showChooseLine;
        },
        curChoosedCoper() {
            return this.$store.state.diagram.curChoosedCoper;
        }
    },
    data() {
        return {
            parentNode: {'name': 'Diagram'},
            clickLocked: false
        }
    },
    mounted: function() {
        setTimeout(() => {
            this.$store.state.timeCurrent = true;
            this.$store.dispatch('diagram/initDiagramRecordList');
            this.$store.dispatch('diagram/resetDiagramFormData');
            this.$store.dispatch('initTimeInputData', {from: 'diagram'})
        }, 20);
    },
    methods: {
        clickShowTimePanelOverlay() {
            this.$store.state.diagram.showTimePanel = false;
        },
        clickStart() {
            let curType = this.$store.state.diagram.curDiagramChooseTypeData.value;
            let typeData = '';
            switch(curType) {
                case 2:
                    let choosedLineData = this.$store.state.diagram.choosedLineData;
                    let choosedLineValues = Object.values(choosedLineData);
                    let hasNotChoosed = choosedLineValues.indexOf(0) >= 0;
                    if(hasNotChoosed) {
                        this.$toast("请指定好六根爻再起卦");
                        return;
                    }
                    typeData = choosedLineValues.join(',').toString();
                    break;
                case 3:
                    let firstDiagramData = this.$store.state.diagram.firstDiagramData;
                    let secondDiagramData = this.$store.state.diagram.secondDiagramData;
                    if(!firstDiagramData || !secondDiagramData) {
                        this.$toast("请指定好主卦和变卦后再起卦");
                        return;
                    }
                    typeData = firstDiagramData.text+','+secondDiagramData.text;
                    break;
                case 4:
                case 5:
                case 6:
                    let diagramNumber = this.$store.state.diagram.curDiagramInputNumber;
                    if(diagramNumber === '') {
                        this.$toast("请完成数字输入再起卦");
                        return; 
                    }
                    typeData = diagramNumber;
                    break;
                case 7:
                    let choosedCoper = this.$store.state.diagram.choosedCoperData;
                    let choosedValues = Object.values(choosedCoper);
                    // console.log('choosedValues-----', choosedValues)
                    if(choosedValues.indexOf(0) >= 0) {
                        return;
                    }
                    typeData = choosedValues.join(',').toString();
                    break;
                default:
                    break;
            }
            if(this.clickLocked) { return; }
            this.clickLocked = true;
            let curPath = this.$router.history.current.path;
            let fullPath = this.$router.history.current.fullPath;
            this.$store.dispatch('diagram/startDiagram', {
                typeData: typeData,
                sucCb: (gId) => {
                    this.clickLocked = false;
                    setTimeout(() => {
                        if(curPath.indexOf('embedded') != -1) {
                            fullPath = fullPath.replace('/diagram', '/diagramdetail/'+gId);
                            this.$router.replace(fullPath);
                        }else {
                            this.$router.replace('/diagramdetail/'+gId);
                        }
                    }, 100);
                }
            });
        },
        clickCancel() {
            this.$store.state.diagram.showChooseType = false;
        },
        clickLineCancel() {
            this.$store.state.diagram.showChooseLine = false;
        }
        
    }
}
</script>